import DashboardLayout from "../../../../Layouts/DashboardLayout";
import ContentBodyWrapper from "../../../../Layouts/Containers/ContentBodyWrapper";
import ContentBodyHeader from "../../../../Layouts/Containers/ContentBodyHeader";
import CreateUserForm from "../../../../components/Forms/CreateUserForm";
import reactRouteList from "../../../../config/react-route-list-config";
import { useTranslation } from "react-i18next";
import { changeBrowserTabTitle } from "../../../../utils/Browser";
import ButtonBlack from "../../../../components/Buttons/ButtonBlack";
export default function UserCreatePage() {
    const [t] = useTranslation();
    changeBrowserTabTitle("Create User");

    const buttons = (
        <ButtonBlack
            to={reactRouteList.loggedRoutes.user_list}
            icon={"material-symbols:arrow-back"}
        >
            {t("Back")}
        </ButtonBlack>
    );

    return (
        <>
            <DashboardLayout>
                <ContentBodyWrapper showFooter={true}>
                    <ContentBodyHeader
                        info={{
                            title: t("Create User"),
                        }}
                        breadcrumb={[
                            {
                                linkitem: t("Users"),
                                link: reactRouteList.loggedRoutes.user_list,
                            },
                            {
                                linkitem: t("Create"),
                                link: reactRouteList.loggedRoutes.create_users,
                            },
                        ]}
                        buttons={buttons}
                    />
                    <CreateUserForm />
                </ContentBodyWrapper>
            </DashboardLayout>
        </>
    );
}
